export default __webpack_public_path__ + "static/media/BasicLife.bf791b9a.svg";